var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSwimlaneGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M3 13a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m12 5a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm-2-4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm8 0a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zM3 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m18 5a1 1 0 1 1 0 2H8.344a1 1 0 1 1 0-2zm-2.812-4a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2z"
})));
export default SvgGemSwimlaneGroup;